import { ADDRESS_ENDPOINTS } from "./endpoints";
import type { Address, AddressInput } from "./types";
import { apiPostWithData } from "../shared/apiClient";
import { DEFAULT_API_OPTIONS } from "./constants";

export default async function saveAddress(addressData: AddressInput): Promise<Address> {
  const endpoint = addressData.id ? ADDRESS_ENDPOINTS.UPDATE : ADDRESS_ENDPOINTS.CREATE;

  return apiPostWithData<Address>(endpoint, addressData, DEFAULT_API_OPTIONS);
}
